const DRAG_HANDLE_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8.5 7C9.03043 7 9.53914 6.78929 9.91421 6.41421C10.2893 6.03914 10.5 5.53043 10.5 5C10.5 4.46957 10.2893 3.96086 9.91421 3.58579C9.53914 3.21071 9.03043 3 8.5 3C7.96957 3 7.46086 3.21071 7.08579 3.58579C6.71071 3.96086 6.5 4.46957 6.5 5C6.5 5.53043 6.71071 6.03914 7.08579 6.41421C7.46086 6.78929 7.96957 7 8.5 7ZM8.5 14C9.03043 14 9.53914 13.7893 9.91421 13.4142C10.2893 13.0391 10.5 12.5304 10.5 12C10.5 11.4696 10.2893 10.9609 9.91421 10.5858C9.53914 10.2107 9.03043 10 8.5 10C7.96957 10 7.46086 10.2107 7.08579 10.5858C6.71071 10.9609 6.5 11.4696 6.5 12C6.5 12.5304 6.71071 13.0391 7.08579 13.4142C7.46086 13.7893 7.96957 14 8.5 14ZM10.5 19C10.5 19.5304 10.2893 20.0391 9.91421 20.4142C9.53914 20.7893 9.03043 21 8.5 21C7.96957 21 7.46086 20.7893 7.08579 20.4142C6.71071 20.0391 6.5 19.5304 6.5 19C6.5 18.4696 6.71071 17.9609 7.08579 17.5858C7.46086 17.2107 7.96957 17 8.5 17C9.03043 17 9.53914 17.2107 9.91421 17.5858C10.2893 17.9609 10.5 18.4696 10.5 19ZM15.5 7C16.0304 7 16.5391 6.78929 16.9142 6.41421C17.2893 6.03914 17.5 5.53043 17.5 5C17.5 4.46957 17.2893 3.96086 16.9142 3.58579C16.5391 3.21071 16.0304 3 15.5 3C14.9696 3 14.4609 3.21071 14.0858 3.58579C13.7107 3.96086 13.5 4.46957 13.5 5C13.5 5.53043 13.7107 6.03914 14.0858 6.41421C14.4609 6.78929 14.9696 7 15.5 7ZM17.5 12C17.5 12.5304 17.2893 13.0391 16.9142 13.4142C16.5391 13.7893 16.0304 14 15.5 14C14.9696 14 14.4609 13.7893 14.0858 13.4142C13.7107 13.0391 13.5 12.5304 13.5 12C13.5 11.4696 13.7107 10.9609 14.0858 10.5858C14.4609 10.2107 14.9696 10 15.5 10C16.0304 10 16.5391 10.2107 16.9142 10.5858C17.2893 10.9609 17.5 11.4696 17.5 12ZM15.5 21C16.0304 21 16.5391 20.7893 16.9142 20.4142C17.2893 20.0391 17.5 19.5304 17.5 19C17.5 18.4696 17.2893 17.9609 16.9142 17.5858C16.5391 17.2107 16.0304 17 15.5 17C14.9696 17 14.4609 17.2107 14.0858 17.5858C13.7107 17.9609 13.5 18.4696 13.5 19C13.5 19.5304 13.7107 20.0391 14.0858 20.4142C14.4609 20.7893 14.9696 21 15.5 21Z" fill="#1C1C1C" /></svg>'

function slugify(text) {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '-').replace(/-{2,}/g, '-').replace(/^-|-$/g, '')
}

function findDropTarget(list, mouseY) {
  let target = null
  let targetOffset = null
  Array.from(list.children).forEach((item) => {
    if (item.classList.contains('dragging')) return
    const box = item.getBoundingClientRect()
    const offset = mouseY - box.top - box.height / 2
    if (offset < 0 && (targetOffset === null || offset > targetOffset)) {
      target = item
      targetOffset = offset
    }
  })
  return target
}

document.addEventListener('turbo:load', () => {
  const editor = document.getElementById('faq-position-editor')
  if (!editor) return

  const container = document.getElementById('faq-position-lists')
  const empty = document.getElementById('faq-position-empty')
  const categorySelect = document.getElementById('faq_faq_category_id')
  const placementsInput = document.getElementById('faq_placements')
  const questionInput = document.getElementById('faq_question')
  const currentId = editor.dataset.currentId
  const originalCategoryId = categorySelect?.value
  let loadToken = 0

  const currentLabel = () => questionInput?.value?.trim() || 'Este FAQ'

  function placements() {
    return [...new Set((placementsInput?.value || '').split(',').map(slugify).filter(Boolean))]
  }

  function badge(text, klass) {
    const span = document.createElement('span')
    span.className = `badge ${klass}`
    span.textContent = text
    return span
  }

  function buildItem(id, text, { current = false, inactive = false } = {}) {
    const item = document.createElement('li')
    item.className = 'list-group-item d-flex align-items-center gap-2'
    item.dataset.faqId = current ? 'atual' : id
    item.draggable = true
    item.style.cursor = 'grab'
    if (current) item.classList.add('list-group-item-primary', 'fw-bold')

    const handle = document.createElement('span')
    handle.className = 'text-muted d-inline-flex'
    handle.setAttribute('role', 'img')
    handle.setAttribute('aria-label', 'Arraste para reordenar')
    handle.innerHTML = DRAG_HANDLE_SVG
    item.appendChild(handle)

    const position = document.createElement('span')
    position.className = 'text-muted small'
    position.style.minWidth = '1.5rem'
    position.dataset.position = 'true'
    item.appendChild(position)

    const label = document.createElement('span')
    label.className = 'flex-grow-1'
    label.textContent = text
    if (current) label.dataset.currentLabel = 'true'
    item.appendChild(label)

    if (current) item.appendChild(badge('Este FAQ', 'bg-primary'))
    if (inactive) item.appendChild(badge('Inativo', 'bg-secondary'))
    return item
  }

  function updateInputs(block) {
    const list = block.querySelector('ol')
    const inputs = block.querySelector('[data-inputs]')
    inputs.innerHTML = ''
    Array.from(list.children).forEach((item, index) => {
      item.querySelector('[data-position]').textContent = `${index + 1}.`
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = `faq[placement_orders][${block.dataset.placement}][]`
      input.value = item.dataset.faqId
      inputs.appendChild(input)
    })
  }

  function buildBlock(placement, faqs) {
    const block = document.createElement('div')
    block.dataset.placement = placement

    const title = document.createElement('div')
    title.className = 'small fw-bold mb-1'
    title.textContent = `Ordem em ${placement}`
    block.appendChild(title)

    const list = document.createElement('ol')
    list.className = 'list-group'
    block.appendChild(list)

    const inputs = document.createElement('div')
    inputs.dataset.inputs = 'true'
    block.appendChild(inputs)

    const sameCategory = categorySelect.value === originalCategoryId
    let hasCurrent = false
    faqs.forEach((faq) => {
      const isCurrent = currentId && String(faq.id) === currentId
      if (isCurrent && !sameCategory) return
      if (isCurrent) hasCurrent = true
      list.appendChild(buildItem(faq.id, isCurrent ? currentLabel() : faq.question, { current: isCurrent, inactive: !faq.active }))
    })
    if (!hasCurrent) list.appendChild(buildItem(null, currentLabel(), { current: true }))

    list.addEventListener('dragstart', (event) => event.target.closest('li')?.classList.add('dragging'))
    list.addEventListener('dragend', (event) => {
      event.target.closest('li')?.classList.remove('dragging')
      updateInputs(block)
    })
    list.addEventListener('dragover', (event) => {
      event.preventDefault()
      const dragging = list.querySelector('.dragging')
      if (!dragging) return
      const target = findDropTarget(list, event.clientY)
      target ? list.insertBefore(dragging, target) : list.appendChild(dragging)
    })

    updateInputs(block)
    return block
  }

  async function fetchFaqs(placement) {
    const url = `${editor.dataset.categoriesUrl}/${categorySelect.value}/faqs?placement=${encodeURIComponent(placement)}`
    const response = await fetch(url, { headers: { Accept: 'application/json' } })
    return response.ok ? response.json() : []
  }

  async function load() {
    const token = ++loadToken
    const slugs = placements()
    if (!categorySelect?.value || slugs.length === 0) {
      container.innerHTML = ''
      empty.classList.remove('d-none')
      return
    }

    const results = await Promise.all(slugs.map(fetchFaqs))
    if (token !== loadToken) return

    container.innerHTML = ''
    slugs.forEach((slug, index) => container.appendChild(buildBlock(slug, results[index])))
    empty.classList.add('d-none')
  }

  categorySelect?.addEventListener('change', load)
  placementsInput?.addEventListener('change', load)
  questionInput?.addEventListener('input', () => {
    container.querySelectorAll('[data-current-label]').forEach((label) => { label.textContent = currentLabel() })
  })

  load()
})
